<template>
  <b-modal
    @show="onShow"
    body-class="md_modal_body_scroll"
    dialog-class="md_modal_dialog_full22"
    modal-class="md_modal_full"
    content-class="md_modal_content_full"
    header-class="dlg_header"
    :visible="visible"
    hide-footer
    hide-backdrop
    no-close-on-backdrop
    @hide="onCancel"
  >
    <template #modal-header="{close}">
      <b-button class="dlg_close_btn" style="background-color: white" variant="white" @click="onCancel">
        <b-img :src="require('../../../assets/image/ic_back.png')" style="height: 1.5em; margin-left: 7px; margin-right: 3px; "/>
      </b-button>
      <div class="popup_title" style="flex: 1; text-align: center;">{{ $t('site_detail.more_locations') }}</div>

    </template>

     <div style="position: absolute; bottom: 215px; right: 15px; z-index: 5" >
            <b-button
              v-if="!loadView"
              pill
              class="map align-horizontal center p-0"
              style="background-color: transparent"
              @click="onRoadView"
            >
              <!--          <b-icon icon="BIconGeoAlt"></b-icon>-->
              <b-img
                class="map_gps_btn"
                :src="
                  require('../../../assets/image/ic_roadview@2x.png')
                "
              />
            </b-button>

            <b-button
              v-if="!loadView"
              pill
              class="map align-horizontal center p-0"
              style="background-color: transparent"
              @click="onDistance"
            >
              <!--          <b-icon icon="BIconGeoAlt"></b-icon>-->
              <b-img
                v-if="showDistance"
                class="map_gps_btn"
                :src="
                  require('../../../assets/image/ic_distance_off@2x.png')
                "
              />
              <b-img
                v-else
                class="map_gps_btn"
                :src="
                  require('../../../assets/image/ic_distance_start@2x.png')
                "
              />
            </b-button>

            <b-button
              v-if="!loadView"
              pill
              class="map align-horizontal center p-0"
              style="background-color: transparent"
              @click="onRadius"
            >
              <!--          <b-icon icon="BIconGeoAlt"></b-icon>-->
              <b-img
                v-if="showRadius"
                class="map_gps_btn"
                :src="
                  require('../../../assets/image/ic_radius_off@2x.png')
                "
              />
              <b-img
                v-else
                class="map_gps_btn"
                :src="
                  require('../../../assets/image/ic_radius_start@2x.png')
                "
              />
            </b-button>
     </div>

    <div class="full align-vertical">

      <iframe ref="webref" id='webref' @load="onLoadEnd" class="flex_1 no_border mb-3" src="https://app.madepf.com/web_map2.html" />
      <MFMap @facilityClick="onFacilityClick" />
    </div>
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils"
import MFMap from "../mf/MFMap";
const utils = require('util');

export default {
  name: "FacilitiesPopup",
  components: {MFMap},
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    site: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      self: this,
      u: Utils,
      ut: utils,
      showDistance: false,
      showRadius: false,
      loadView: false
    }
  },
  mounted() {
    window.addEventListener("message", this.onMessage, false);
  },
  computed: {
  },
   beforeDestroy() {
    window.removeEventListener("message", this.onMessage);
  },
  methods:{
    onLoadEnd() {
      this.$refs.webref.contentWindow.postMessage(
        { type:'1', lat: this.site.f_latitude, lon: this.site.f_longitude, state:this.site.f_site_type, title:this.site.f_name },
         '*'
      );

    },

    onMessage (e) {
       let data = JSON.parse(e.data);

      if (data.type == "3") {
        Utils.toast(this, this.$t("거리 설정 후 마우스 우클릭을 눌러주세요."));
      } else if (data.type == "4") {
        Utils.toast(this, this.$t("반경 설정 후 마우스 우클릭을 눌러주세요."));
      } else if (data.type == "20") {
        this.loadView = !this.loadView;
      }
    },

    onFacilityClick (item) {
      this.$refs.webref.contentWindow.postMessage(
        { type:'2', state: item.active, idx: item.idx },
         '*'
      );
    },

    onRoadView ()  {
      this.loadView = !this.loadView;
      this.$refs.webref.contentWindow.postMessage(
        { type:'3', state: this.loadView},
          '*'
      );
    },
    onShow() {
    },
    onCancel()  {
      this.$emit('update:visible', false);

    },

    onDistance() {
      if (this.showDistance) {
        this.$refs.webref.contentWindow.postMessage(
          {
            type: "5",
            state: "2",
          },
          "*"
        );
      } else {
        this.$refs.webref.contentWindow.postMessage(
          {
            type: "5",
            state: "1",
          },
          "*"
        );
      }

      this.showDistance = !this.showDistance;
    },

    onRadius() {
      if (this.showRadius) {
        this.$refs.webref.contentWindow.postMessage(
          {
            type: "6",
            state: "2",
          },
          "*"
        );
      } else {
        this.$refs.webref.contentWindow.postMessage(
          {
            type: "6",
            state: "1",
          },
          "*"
        );
      }

      this.showRadius = !this.showRadius;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_vars.scss";
.header {height: 50px ; background-color: $white }
.back_btn {width: 40px ; align-items: center ; justify-content: center ;  position: absolute ;   top: 15px }
.page_title {color: $black ; font-size: $fs_16 }
.road_btn {
  width: 30px ;
  height: 30px;
  align-items: center ;
  justify-content: center ;
  position: absolute ;
  top: 10px ;
  right: 15px ;
 }
.map {width: 100% ; height: 100% ; background-color: #94d2a5 }
.map_btns {position: absolute ; right: 20px ; bottom: 16px }
.facility_wrapper {background-color: $white }
.facility_header {height: 48px ; border-bottom:solid 1px #dcdcdc; }
.facility_tab {
  flex: 1 ;
  align-items: center ;
  justify-content: center ;
  border-bottom:solid 3px transparent ;
 }
.facility_tab_text {font-size: $fs_14 ; color: #c9c8c8 ; font-family: $korean_gd_15_r }
.facility_tab_active_text {color: $c_457fff }
.facility_tab_active {border-bottom-color: $c_457fff }
.facility_items {height: 102px }
.facility_item {flex: 1 ; align-items: center ; justify-content: center }
.facility_item_text {
  font-size: $fs_12 ;
  font-family: $korean_gd_15_r ;
  color: #242424 ;
  margin-top: 12px ;
 }
.filter_pane {position: absolute ; top: 0 ; left: 0 ; width: 100% ; height: 100% }

@import "../../../assets/css/main/map/Map.scss";
.map_gps_btn {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/FacilitiesPopup.vue